import api from '../../plugins/api'

export const SolicitacaoPagamento = {
    namespaced: true,
    state() {
        return {
            tipos_documento: [],
            despesas: [],
            fornecedor: {
                id: '',
                codigo: '',
                cpf_cnpj: '',
                nome: '',
                email: '',
                telefone: '',
                celular: '',
                token: '',
                validade: ''
            },
            condominio: {
                codigo: '',
                cnpj: '',
                nome: ''
            }
        }
    },
    actions: {
        async loadTiposDocumento({ commit }) {
            try {

                let { data: tipos_documento } = await api.get('solicitacao-pagamento/tipos-documento-financeiro');                
                commit('setTiposDocumento', tipos_documento)
            } catch (err) {
                console.error(err);
            }
        },
        async loadDespesas({ commit }) {
            try {

                if (!this.condominio || !this.condominio.codigo) {
                   // return;
                }
                let { data: despesas } = await api.get('solicitacao-pagamento/despesas');
                commit('setDespesas', despesas);
            } catch (err) {
                console.error(err);
            }
        },
        reset({ commit }) {
            commit('setFornecedor', {
                id: '',
                codigo: '',
                cpf_cnpj: '',
                nome: '',
                email: '',
                telefone: '',
                celular: ''
            })
            commit('setCondominio',{ commit }, {
                codigo: '',
                cnpj: '',
                nome: ''
            })
        },
        resetCondominio({ commit }) {
            
            commit('setCondominio', { commit }, {
                codigo: '',
                cnpj: '',
                nome: ''
            })
        },
        async registerFornecedor({ commit }, fornecedor) {
            await api.post(`/fornecedor/registrar`, fornecedor)
            commit('setFornecedor', fornecedor)

        }
    },
    mutations: {
        setFornecedor(state, fornecedor) {
            state.fornecedor = fornecedor
        },
        setCondominio(state, condominio) {
            state.condominio = condominio
        },
        setTiposDocumento(state, tipos_documento) {
            state.tipos_documento = tipos_documento
        },
        setDespesas(state, despesas) {
            state.despesas = despesas
        }
    },
    getters: {
        
    }
}